export function useUploadSources() {
  const config = useRuntimeConfig();

  const userAgent =
    process.client ? navigator.userAgent : 'server';

  const appVersion = config.public.appVersion;

  return {
    defaultUploadSource: `core_web_ui-${appVersion}-${userAgent}`.slice(0, 255),
    adminUploadSource: `core_web_ui_admin-${appVersion}-${userAgent}`.slice(0, 255),
    surfaceEditorAlbumCover: `surface_editor-album_cover-${appVersion}-${userAgent}`.slice(0, 255)
  };
}
